import {POSITION, useToast} from 'vue-toastification';
import {Capacitor} from '@capacitor/core';
import {myAxios} from '@/http';
import {BiometricAuth} from '@aparajita/capacitor-biometric-auth';
import i18n from '@/i18n';

export const toastConfig = {
    position: POSITION.BOTTOM_LEFT,
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
}

export const formatYearsString = (years) => {
    if (years === 1) {
        return years + ' rok';
    }
    if (years >= 2 && years <= 4) {
        return years + ' roky';
    }
    // Jazyk se určuje podle domény přes getLangToSet() (stejně jako v App.vue).
    // localStorage['lang'] nepoužíváme – nastavuje ho jen LangSwitcher, který je
    // v sidebaru skrytý, takže by na SK doméně byl prázdný a vracelo by se "let".
    return years + (getLangToSet() === 'sk' ? ' rokov' : ' let');
}

export const formatDate = (date, format = 'd.m.Y H:i:s') => {
    if (!(date instanceof Date) && typeof date !== 'string') {
        return '';
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }

    const monthsShort = ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"];
    const monthsFull = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
    const daysShort = ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"];
    const daysFull = ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"];
    return format.replace(/Y|y|m|n|d|j|H|h|i|s|M|F|l|D|z|N|w|U|A|a|G|g/g, (match) => {
        switch (match) {
            case 'Y':
                return date.getFullYear();
            case 'y':
                return String(date.getFullYear()).slice(-2);
            case 'm':
                return String(date.getMonth() + 1).padStart(2, '0');
            case 'n':
                return String(date.getMonth() + 1);
            case 'd':
                return String(date.getDate()).padStart(2, '0');
            case 'j':
                return String(date.getDate());
            case 'H':
                return String(date.getHours()).padStart(2, '0');
            case 'h':
                return String((date.getHours() % 12) || 12).padStart(2, '0');
            case 'i':
                return String(date.getMinutes()).padStart(2, '0');
            case 's':
                return String(date.getSeconds()).padStart(2, '0');
            case 'M':
                return monthsShort[date.getMonth()];
            case 'F':
                return monthsFull[date.getMonth()];
            case 'l':
                return daysFull[date.getDay()];
            case 'D':
                return daysShort[date.getDay()];
            case 'z':
                return String(Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 86400000)).padStart(3, '0');
            case 'N':
                return String(date.getDay() === 0 ? 7 : date.getDay());
            case 'w':
                return String(date.getDay());
            case 'U':
                return String(Math.floor(date.getTime() / 1000));
            case 'A':
                return date.getHours() >= 12 ? 'PM' : 'AM';
            case 'a':
                return date.getHours() >= 12 ? 'pm' : 'am';
            case 'G':
                return String(date.getHours());
            case 'g':
                return String((date.getHours() % 12) || 12);
            default:
                return match;
        }
    });
}


export const formatAmount = (value, currency, digits = 2, absolute = false) => {

    if(!currency) {
        currency = 'CZK';
    }

    if(absolute) {
        value = Math.abs(value);
    }

    if (currency) {
        let formatter = new Intl.NumberFormat('cs-CZ', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: digits,
        minimumFractionDigits: digits
        });
        return formatter.format(value);
    } else {
        return value.toLocaleString() + ',-';
    }

}

export const formatNumber = (value, digits = 2, absolute = false) => {
    if(absolute) {
        value = Math.abs(value);
    }
    return new Intl.NumberFormat('cs-CZ', {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits
    }).format(value);
}

export const formatPercents = (value) => {
    //let percents = value * 100;
    return value.toFixed(2) + ' %';
}



export const detectMin = (data) => {

    let min = 99999999999;
    data.forEach(item => {
        if(item < min) {
            min = item;
        }
    });
    return min;

}

export const detectMinInSecondIndex = (data) => {

    let min = 99999999999;
    data.forEach(item => {
        if(item[1] < min) {
            min = item[1];
        }
    });
    return min;

}


export const detectMax = (data) => {

    let max = -99999999999;
    data.forEach(item => {
        if(item > max) {
            max = item;
        }
    });
    return max;

}

export const detectMaxInSecondIndex = (data) => {

    let max = -99999999999;
    data.forEach(item => {
        if(item[1] > max) {
            max = item[1];
        }
    });
    return max;

}


export const detectMinMax = (data) => {

    let max = -99999999999;
    let min = 99999999999;
    data.forEach(item => {
        if(item > max) {
            max = item;
        }
        if(item < min) {
            min = item;
        }
    });
    return [min,max];

}

export const detectMinMaxInSecondIndex = (data) => {

    let max = -99999999999;
    let min = 99999999999;
    data.forEach(item => {
        if(item[1] > max) {
            max = item[1];
        }
        if(item[1] < min) {
            min = item[1];
        }
    });
    return [min,max];

}

// Backend někdy posílá jako "message" i18n klíč (např. "auth.token_expired", "global.permission_denied")
// místo hotového textu - pokud klíč existuje v katalogu, přeložíme ho, jinak zobrazíme text tak, jak přišel.
const translateIfKey = (message) => {
    if (typeof message === 'string' && i18n.global.te(message)) {
        return i18n.global.t(message);
    }
    return message;
}

// Zobrazuje se jen popisek pro uživatele - samotná hodnota role (enum string, i to, jak se s ní
// pracuje v permission checkách/API) zůstává nezměněná. Role bez záznamu v katalogu (např. ADMIN,
// CLIENT) se zobrazí tak, jak přišly - nezasahujeme do jejich zobrazení.
export const translateRole = (role) => {
    const key = `roles.${role}`;
    if (role && i18n.global.te(key)) {
        return i18n.global.t(key);
    }
    return role;
}

export const showSuccessMessage = (message = 'Změna byla úspěšně provedena') => {
    const toast = useToast();
    toast.success(translateIfKey(message), toastConfig);
}

export const showErrorMessage = (message = 'Něco se pokazilo') => {
    const toast = useToast();
    toast.error(translateIfKey(message), toastConfig);
}

export const durationToTime = (duration, showHours = true) => {
    if (showHours) {
        if (duration < 0) {
            return '00:00:00';
        }
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
        if (duration < 0) {
            return '00:00';
        }
        const minutes = Math.floor(duration / 60);
        const seconds = Math.floor(duration % 60);
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    }
}

export const setButtonContentSuccess = (buttonId) => {
    const button = document.getElementById(buttonId);
    if (button) {
        button.classList.add('btn-content--success');
        button.classList.remove('btn-content--loading');
    }
}

export const setButtonContentLoading = (buttonId) => {
    const button = document.getElementById(buttonId);
    if (button) {
        button.classList.add('btn-content--loading');
    }
}

export const setButtonContentDefault = (buttonId) => {
    const button = document.getElementById(buttonId);
    if (button) {
        button.classList.remove('btn-content--success');
        button.classList.remove('btn-content--loading');
    }
}

export const setButtonsContentLoading = (buttonsClass) => {
    const buttons = document.getElementsByClassName(buttonsClass);
    console.log(buttons);
    for (const btn of buttons) {
        btn.classList.add('btn-content--loading');
    }
}

export const setButtonsContentSuccess = (buttonsClass) => {
    const buttons = document.getElementsByClassName(buttonsClass);
    for (const btn of buttons) {
        btn.classList.add('btn-content--success');
        btn.classList.remove('btn-content--loading');
    }
}

/** Vrátí tlačítka zpět do výchozího stavu po chybě — jinak zůstanou trvale v "loading". */
export const setButtonsContentDefault = (buttonsClass) => {
    const buttons = document.getElementsByClassName(buttonsClass);
    for (const btn of buttons) {
        btn.classList.remove('btn-content--success');
        btn.classList.remove('btn-content--loading');
    }
}

export const codePreview = (codeFormat) => {
    if (codeFormat) {
        const dateFormatters = ['Y', 'y', 'm', 'n', 'd', 'j', 'H', 'h', 'i', 's', 'M', 'F', 'l', 'D', 'z', 'N', 'w', 'U', 'A', 'a', 'G', 'g'];
        dateFormatters.forEach((formatter) => {
            codeFormat = codeFormat.replace(`%${formatter}%`, formatDate(new Date(), `${formatter}`));
        });
        codeFormat = codeFormat.replace(/%NMB_(\d+)%/, (_, digits) => {
            const numDigits = parseInt(digits, 10);
            return '1'.padStart(numDigits, '0'); // Pads the number with leading zeros
        });
    }
    return codeFormat;
}

export const startAppLoader = () => {
    const interval = setInterval(() => {
        const loader = document.getElementById('app-loader');
        if (loader) {
            clearInterval(interval);
            loader.classList.remove('d-none');
            setTimeout(() => {
                loader.classList.add('d-none');
            }, 1500);
        }
    }, 10);
}

const DEFAULT_TICK_COUNT = 4;
const NICE_FRACTIONS = [1, 1.25, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

const normalizeValue = (value) => {
    if (!Number.isFinite(value)) {
        return 0;
    }

    const rounded = Number(value.toPrecision(12));
    return Object.is(rounded, -0) ? 0 : rounded;
};

const getNiceStep = (value) => {
    if (!Number.isFinite(value) || value === 0) {
        return 0;
    }

    const absValue = Math.abs(value);
    const exponent = Math.floor(Math.log10(absValue));
    const base = Math.pow(10, exponent);
    const fraction = absValue / base;

    for (const nice of NICE_FRACTIONS) {
        if (fraction <= nice) {
            return nice * base;
        }
    }

    return 10 * base;
};

const getNextNiceStep = (currentStep) => {
    if (!Number.isFinite(currentStep) || currentStep === 0) {
        return currentStep;
    }

    const absValue = Math.abs(currentStep);
    const exponent = Math.floor(Math.log10(absValue));
    const base = Math.pow(10, exponent);
    const fraction = absValue / base;

    for (const nice of NICE_FRACTIONS) {
        if (fraction < nice - 1e-12) {
            const next = nice * base;
            return currentStep < 0 ? -next : next;
        }
    }

    const next = 10 * base;
    return currentStep < 0 ? -next : next;
};

const getTickSpan = (step, minimalValue, maximalValue) => {
    if (!Number.isFinite(step) || step <= 0) {
        return 0;
    }

    const lower = Math.floor(minimalValue / step);
    const upper = Math.ceil(maximalValue / step);
    return upper - lower;
};

const buildAxisRange = (minimalValue, maximalValue) => {
    const diff = maximalValue - minimalValue;
    const rawStep = diff / DEFAULT_TICK_COUNT;
    let step = getNiceStep(rawStep) || rawStep || 1;

    if (!Number.isFinite(step) || step <= 0) {
        step = rawStep || 1;
    }

    let tickSpan = getTickSpan(step, minimalValue, maximalValue);
    let guard = 0;

    while (tickSpan > DEFAULT_TICK_COUNT && guard < 20) {
        const nextStep = getNextNiceStep(step);
        if (!Number.isFinite(nextStep) || nextStep <= step) {
            break;
        }
        step = nextStep;
        tickSpan = getTickSpan(step, minimalValue, maximalValue);
        guard += 1;
    }

    if (tickSpan < DEFAULT_TICK_COUNT || !Number.isFinite(step) || step <= 0) {
        step = rawStep || 1;
        tickSpan = getTickSpan(step, minimalValue, maximalValue);
    }

    if (tickSpan !== DEFAULT_TICK_COUNT) {
        const fallbackStep = rawStep || 1;
        return {
            min: normalizeValue(minimalValue),
            max: normalizeValue(maximalValue),
            step: normalizeValue(fallbackStep)
        };
    }

    let minIndex = Math.floor(minimalValue / step);
    let maxIndex = Math.ceil(maximalValue / step);
    let span = maxIndex - minIndex;

    while (span < DEFAULT_TICK_COUNT) {
        const lowerGap = minimalValue - minIndex * step;
        const upperGap = maxIndex * step - maximalValue;
        if (lowerGap >= upperGap) {
            minIndex -= 1;
        } else {
            maxIndex += 1;
        }
        span = maxIndex - minIndex;
    }

    const min = normalizeValue(minIndex * step);
    const max = normalizeValue(maxIndex * step);

    return {
        min,
        max,
        step: normalizeValue(step)
    };
};

export const roundMinMaxValues = (minimalValue, maximalValue) => {
    if (!Number.isFinite(minimalValue) || !Number.isFinite(maximalValue)) {
        return { min: 0, max: 0, step: 1 };
    }

    if (minimalValue > maximalValue) {
        [minimalValue, maximalValue] = [maximalValue, minimalValue];
    }

    const diff = maximalValue - minimalValue;

    if (diff === 0) {
        const base = Math.max(Math.abs(maximalValue), 1);
        const padding = getNiceStep(base / DEFAULT_TICK_COUNT) || base / DEFAULT_TICK_COUNT || 1;
        const halfSpan = padding * (DEFAULT_TICK_COUNT / 2);
        return buildAxisRange(minimalValue - halfSpan, maximalValue + halfSpan);
    }

    return buildAxisRange(minimalValue, maximalValue);
}

export const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\+(\d{12})$/;          // use case for czech etc... -> +420 123 456 789
    const phoneRegex2 = /^\+(\d{11})$/;         // use case for swiss etc... -> +41 123 456 789
    const phoneRegex3 = /^\+(\d{13})$/;                                       // use case this phone: +436 901 062 6335
    return phoneRegex.test(phone) || phoneRegex2.test(phone) || phoneRegex3.test(phone);
}

// domains: SK, CZ, SK/CZ
export const setDomain = (domain) => {
    localStorage.setItem('IE_DOMAIN', domain);
    window.location.reload();
}

export const getAppDomain = () => {
    if (process.env.NODE_ENV !== 'production') {
        return 'CZ';
    }
    // if platform is web, detect domain from URL
    if (!Capacitor.isNativePlatform()) {
        let domain = 'SK';
        if (document.location.href.includes('biginvest.cz') || document.location.href.includes('in-equity.sk/cz')) {
            domain = 'SK/CZ';
        }
        if (document.location.href.includes('in-equity.cz')) {
            domain = 'CZ';
        }
        return domain;
    }

    // if platform is capacitor, get domain from localStorage
    const lsValue = localStorage.getItem('IE_DOMAIN');

    checkIeDomainIsSet(lsValue);

    if (lsValue === null || lsValue === undefined) {
        if (Capacitor.isNativePlatform()) {
            return null;
        }
    }
    return lsValue;
}

// SK a SK/CZ ("Pobočka") tenanti byli přebrandováni na "B.I.G. Invest" — jen CZ zůstává "IN Equity".
// Na rozdíl od window.location.hostname.includes('biginvest') funguje správně i v Capacitor appce,
// kde se doména bere z localStorage, ne z hostname.
export const isRebrandedTenant = () => getAppDomain() !== 'CZ';

export const isTestEnvironment = () => {
    return document.location.href.includes('test-my.in-equity');
}

export const getBiometricLSKeyByDomain = (key) => {
    if (getAppDomain() === 'SK') {
        return key + '_SK';
    }
    if (getAppDomain() === 'SK/CZ') {
        return key + '_SK/CZ';
    }
    return key;
}

export const allowedBiometricAuth = async () => {
    const biometricInfo = await BiometricAuth.checkBiometry();

    if ((process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') && Capacitor.isNativePlatform() && biometricInfo.isAvailable) {
        const isActive = localStorage.getItem(getBiometricLSKeyByDomain('BIOMETRIC_ACTIVE'));
        const uuid = localStorage.getItem(getBiometricLSKeyByDomain('BIOMETRIC_UUID'));

        if (isActive && uuid) {
            return true;
        }
    }

    return false;
}

export const allowedBankID = () => {
    return getAppDomain() === 'CZ' || getAppDomain() === 'SK/CZ';
}

export const getLangToSet = () => {
    if (process.env.NODE_ENV !== 'production') {
        return 'cs';
    }

    const domain = getAppDomain();
    if (domain === 'SK/CZ' || domain === 'CZ') {
        return 'cs';
    } else {
        return 'sk';
    }
}

export const getApiBaseUrl = () => {
    if (getAppDomain() === 'SK/CZ') {
        return process.env.VUE_APP_API_URL_SK_CZ;
    }
    if (getAppDomain() === 'SK') {
        return process.env.VUE_APP_API_URL_SK;
    }
    return isTestEnvironment() ? process.env.VUE_APP_API_URL_TEST : process.env.VUE_APP_API_URL;
}

export const checkIeDomainIsSet = (domainToCheck) => {
    if (domainToCheck !== 'SK' && domainToCheck !== 'CZ' && domainToCheck !== null && domainToCheck !== undefined) {
        localStorage.removeItem('IE_DOMAIN');
        window.location.reload();
    }
}

export const getFrontendBase = () => {
    if (getAppDomain() === 'SK/CZ' && document.location.href.includes('in-equity.sk/cz') && !Capacitor.isNativePlatform()) {
        return '/cz/'
    }
    return '/';
}

export const kebabToCamel = (str) => {
    return str
        .split('-')               // rozdělíme podle "-"
        .map((word, index) => {
            if (index === 0) return word.toLowerCase(); // první slovo malé
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // ostatní slova s velkým začátkem
        })
        .join('');                // spojíme zpět dohromady
}

/**
 * Zamaskuje telefonní číslo pro zobrazení ve tvaru "+420 123 xxx x12".
 *
 * Předvolba CZ/SK (+420/+421, i zápis 00420) zůstane čitelná. Z čísla za předvolbou zůstanou
 * čitelné první tři a poslední dvě číslice, aby si uživatel číslo poznal, ostatní se nahradí
 * znakem "x" a vše se seskupí po třech. U jiných předvoleb se pravidlo uplatní na celé číslo
 * za "+" (z čísla nelze spolehlivě poznat, kolik číslic patří k předvolbě). Mezery, pomlčky
 * a závorky v čísle se ignorují.
 *
 * @param {string|null|undefined} phoneNumber číslo tak, jak přišlo z backendu nebo formuláře
 * @returns {string} zamaskované číslo; prázdný řetězec, pokud číslo chybí
 */
export const maskPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return '';
    }

    // zachovat jen číslice a úvodní "+", zápis "00" převést na "+"
    let compact = String(phoneNumber).replace(/[^\d+]/g, '').replace(/^00/, '+');
    let prefix = '';

    const knownPrefix = compact.match(/^\+(420|421)/);
    if (knownPrefix) {
        prefix = '+' + knownPrefix[1];
        compact = compact.slice(prefix.length);
    } else if (compact.startsWith('+')) {
        prefix = '+';
        compact = compact.slice(1);
    }

    const digits = compact.replace(/\D/g, '');
    if (digits.length <= 2) {
        return phoneNumber;
    }

    // u krátkého čísla by první tři a poslední dvě číslice odkryly všechno - pak jen poslední dvě
    const visibleStart = digits.length > 5 ? 3 : 0;
    const masked = digits.slice(0, visibleStart) + 'x'.repeat(digits.length - visibleStart - 2) + digits.slice(-2);
    // seskupit po třech zprava, aby poslední skupina vždy končila viditelnými číslicemi
    const groups = [];
    for (let end = masked.length; end > 0; end -= 3) {
        groups.unshift(masked.slice(Math.max(0, end - 3), end));
    }
    const grouped = groups.join(' ');

    // u neznámé předvolby se "+" připojí rovnou k číslicím ("+4 91x xxx xxx x78")
    if (prefix === '+') {
        return prefix + grouped;
    }
    return prefix ? `${prefix} ${grouped}` : grouped;
}

/**
 * Reads a CSS custom property value from :root.
 * Falls back to the provided default if the variable is not yet set.
 */
export function getCssVar(name, fallback = '') {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
}

/**
 * Returns '#ffffff' or '#000000' — whichever has better WCAG contrast against the given hex color.
 * Accepts 3- or 6-digit hex strings (with or without '#').
 */
export function getContrastColor(hex) {
    let clean = hex.replace('#', '').trim();
    if (clean.length === 3) clean = clean.split('').map(c => c + c).join('');
    if (clean.length !== 6) return '#ffffff';
    const r = parseInt(clean.substr(0, 2), 16) / 255;
    const g = parseInt(clean.substr(2, 2), 16) / 255;
    const b = parseInt(clean.substr(4, 2), 16) / 255;
    // Relative luminance per WCAG 2.1
    const lin = c => c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    const L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    return L > 0.179 ? '#000000' : '#ffffff';
}

export const appendFormData = (formData, data, parentKey = '') => {
    if (data && typeof data === 'object' && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            const value = data[key];
            const formKey = parentKey
                ? `${parentKey}[${key}]`
                : key;

            appendFormData(formData, value, formKey);
        });
    } else {
        formData.append(parentKey, data ?? '');
    }
}
